export const POST_INFO = 'POST_INFO';
export const POST_INFO_SUCCESS = 'POST_INFO_SUCCESS';
export const POST_INFO_FAIL = 'POST_INFO_FAIL';
export const POST_WATCHED = 'POST_WATCHED';
export const POST_LIKED = 'POST_LIKED';
export const POST_LIKED_SUCCESS = 'POST_LIKED_SUCCESS';
